import { useDispatch } from 'react-redux'
import { useEffect } from 'react'
import { useFormikContext } from 'formik'

import {
  FuneralPlanLeadAttributes,
  LeadAttributes,
  ProbateLeadAttributes,
  WillLeadAttributes,
} from 'lib/models/lead'
import { ResponseMeta } from 'lib/types'
import { useLeadContext } from 'routes/lead/context'
import { hideModal } from 'state/actions'

import { MergeWarningData } from './config'
import { MergeWarningBase } from './merge-warning-base'
import { getMergeWarning, parseMergeWarningData } from './utils'

export const MergeWarningForLeadPage = ({
  apiMessages,
}: {
  apiMessages: ResponseMeta['messages']
}) => {
  const dispatch = useDispatch()
  const { lead, updateContact } = useLeadContext()
  const { values, setFieldValue } = useFormikContext<
    | FuneralPlanLeadAttributes
    | LeadAttributes
    | ProbateLeadAttributes
    | WillLeadAttributes
  >()

  const mergeWarning = getMergeWarning(apiMessages)

  useEffect(() => {
    if (mergeWarning) {
      setFieldValue('contact.email', '')
    }
  }, [setFieldValue, mergeWarning])

  if (!mergeWarning) return <></>

  const mergeWarningData = parseMergeWarningData(mergeWarning)
  const thisContactName =
    `${lead.attributes.contact.firstName} ${lead.attributes.contact.lastName}`.trim()

  return (
    <MergeWarningBase
      mergeWarningData={mergeWarningData}
      thisContactName={thisContactName}
      mergeContact={async () => {
        const updatedLeadResponse = await updateContact(
          {
            name: 'contact.email',
            value: (mergeWarningData as MergeWarningData).email,
          },
          true
        )

        const updatedContact = updatedLeadResponse.data.attributes.contact

        setFieldValue('contact.email', updatedContact.email)

        if (values.contact.id !== updatedContact.id) {
          /** This means the contact was merged into another contact,
           * so we update Formik's value for the contactId from the
           * deleted contact to this other one.*/
          setFieldValue('contactId', updatedContact.id)
          setFieldValue('contact', updatedContact)
        }
        dispatch(hideModal())
      }}
    />
  )
}
